module.exports = __webpack_public_path__ + "static/media/lingshou-1.8bd56973.png";